import * as React from "react";
import { useSelector } from "react-redux";

function RateLabIcon({ width = 17, height = 17, ...props }) {
    const { isDarkTheme } = useSelector(({ common }) => common);
    return (
        <span className="anticon iiht-sidebar-icons ant-menu-item-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width={width}
                height={height} viewBox="0 0 24 24" {...props}><path fill={isDarkTheme ? "#62BAB3" : "#3c4252"} d="M9.6 15.65L12 13.8l2.4 1.85l-.9-3.05l2.25-1.6h-2.8L12 7.9l-.95 3.1h-2.8l2.25 1.6zM5.825 21l2.325-7.6L2 9h7.6L12 1l2.4 8H22l-6.15 4.4l2.325 7.6L12 16.3zM12 11.775" /></svg>
        </span>
    );
}

export default RateLabIcon;

